jQuery(document).foundation();
/*
These functions make sure WordPress
and Foundation play nice together.
*/
var is_open = 0;

jQuery(document).ready(function($) {
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds	
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen flex-video'/>");
		} else {
		  jQuery(this).wrap("<div class='flex-video'/>");
		}
	});



  
	$(".closebtn").click(function () {
		closeNav();
		document.getElementById("nav").classList.toggle("change");
	});

	$("#nav").click(function () {
		
		if (!is_open) {
			openNav();
		} else {
			closeNav()
		}

		this.classList.toggle("change");

	});

});



/* Set the width of the side navigation to 250px */
function openNav() {
	document.getElementById("mySidenav").style.left = 0;
	is_open = 1;
}

/* Set the width of the side navigation to 0 */
function closeNav() {
	document.getElementById("mySidenav").style.left = "-340px";
	is_open = 0;
} 

